import Counter from "ds/components/Counter";
import { useToggle } from "hooks/useToggle";
import CardCollapsible from "ds/components/Card/Collapsible";
import { withTestId } from "utils/withTestId";

import { ReplanRequestChangeType } from "./types";
import ReplanRequestChange from "./Change";

type ReplanRequestChangesProps = {
  title: string;
  changes: ReplanRequestChangeType[];
  "data-testid"?: string;
};

function ReplanRequestChanges({
  title,
  changes,
  "data-testid": dataTestId,
}: ReplanRequestChangesProps) {
  const [isCollapsed, toggle] = useToggle(true);

  return (
    <CardCollapsible
      {...withTestId(dataTestId)}
      ariaLabel={`${title}. ${changes.length} elements.`}
      ariaLevel={4}
      title={title}
      titleSuffix={<Counter count={changes.length} />}
      isCollapsed={isCollapsed}
      onToggle={toggle}
      size="small"
    >
      {changes.map((change) => (
        <ReplanRequestChange key={change.id} change={change} />
      ))}
    </CardCollapsible>
  );
}

export default ReplanRequestChanges;
